(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omra-coffee-collection"]) return;
  try {
    
  const mobileFilterQuery = window.matchMedia('(max-width: 749px)');
  document.querySelectorAll('.omra-filter-group').forEach((group) => {
    if (!mobileFilterQuery.matches) group.setAttribute('open', '');
  });
  let previousMobileState = mobileFilterQuery.matches;
  mobileFilterQuery.addEventListener('change', (event) => {
    if (event.matches === previousMobileState) return;
    document.querySelectorAll('.omra-filter-group').forEach((group) => {
      if (event.matches) group.removeAttribute('open');
      else group.setAttribute('open', '');
    });
    previousMobileState = event.matches;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omra-edition-purchase"] && !Shopify.designMode) return;
  try {
    
  function initEditionPurchases(root) {
    root.querySelectorAll('[data-edition-purchase]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const variants = JSON.parse(section.querySelector('[data-purchase-variants]').textContent);
      const labels = JSON.parse(section.querySelector('[data-purchase-labels]').textContent);
      const form = section.querySelector('form');
      const field = section.querySelector('[data-purchase-variant]');
      const quantity = form.querySelector('[name="quantity"]');
      const button = section.querySelector('[data-purchase-add]');
      const opening = document.querySelector('[data-edition-opening]');
      const openingForm = opening?.querySelector('form');
      if (openingForm) section.dataset.linkedOpening = 'true';
      const openingVariant = opening?.querySelector('[data-edition-variant]');
      const openingQuantity = openingForm?.querySelector('[name="quantity"]');
      const update = () => {
        const variant = variants.find(v => String(v.id) === field.value);
        if (!variant) return;
        button.disabled = !variant.available;
        section.querySelector('[data-purchase-price]').textContent = variant.price;
        section.querySelector('[data-purchase-label]').textContent = variant.available ? labels.add : labels.soldOut;
        quantity.min = variant.min;
        quantity.step = variant.step;
        if (variant.max != null) quantity.max = variant.max; else quantity.removeAttribute('max');
        const value = Number(quantity.value) || variant.min;
        quantity.value = Math.min(variant.max ?? Infinity, variant.min + Math.max(0,Math.round((value-variant.min)/variant.step))*variant.step);
        const currentQuantity = Number(quantity.value);
        section.querySelectorAll('[data-purchase-step]').forEach(stepButton => {
          const direction = Number(stepButton.dataset.purchaseStep);
          stepButton.disabled = direction < 0 ? currentQuantity <= variant.min : (variant.max != null && currentQuantity >= variant.max);
        });
      };
      field.addEventListener('change', () => {
        update();
        if (openingVariant && openingVariant.value !== field.value) {
          openingVariant.value = field.value;
          openingVariant.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      openingVariant?.addEventListener('change', () => { field.value = openingVariant.value; update(); });
      openingQuantity?.addEventListener('change', () => { quantity.value = openingQuantity.value; update(); });
      opening?.addEventListener('omra:edition-quantity', event => { quantity.value = event.detail.quantity; update(); });
      quantity.addEventListener('change', () => {
        update();
        if (openingQuantity) {
          openingQuantity.value = quantity.value;
          openingQuantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      section.querySelectorAll('[data-purchase-step]').forEach(stepButton => {
        stepButton.addEventListener('click', () => {
          const direction = Number(stepButton.dataset.purchaseStep) || 0;
          const step = Number(quantity.step) || 1;
          const min = Number(quantity.min) || 1;
          const max = quantity.max ? Number(quantity.max) : Infinity;
          const current = Number(quantity.value) || min;
          quantity.value = String(Math.min(max, Math.max(min, current + direction * step)));
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      form.addEventListener('submit', event => {
        if (!openingForm || opening.dataset.editionReady !== 'true' || !openingForm.requestSubmit) return;
        const openingAdd = opening.querySelector('[data-edition-add]');
        if (!openingAdd || openingAdd.disabled) { event.preventDefault(); return; }
        event.preventDefault();
        openingVariant.value = field.value;
        openingQuantity.value = quantity.value;
        openingQuantity.dispatchEvent(new Event('change', { bubbles: true }));
        openingForm.requestSubmit(openingAdd);
      });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initEditionPurchases(document), { once: true });
  else initEditionPurchases(document);
  document.addEventListener('shopify:section:load', event => initEditionPurchases(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omra-editions-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const applyEditionSourceTag = () => {
      const params = new URLSearchParams(window.location.search);
      if (
        params.get('utm_source') !== 'instagram' ||
        params.get('utm_medium') !== 'organic_social' ||
        params.get('utm_campaign') !== 'forage_autumn_26'
      ) return;

      const content = params.get('utm_content');
      if (!content) return;

      const contentTag = content
        .toLowerCase()
        .replace(/[^a-z0-9_-]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 40)
        .replace(/-+$/g, '');

      if (!contentTag) return;

      const sourceTag = `forage-social-${contentTag}`;
      document.querySelectorAll('[data-editions-source-tags]').forEach((input) => {
        const tags = input.value.split(',').map((tag) => tag.trim()).filter(Boolean);
        if (!tags.includes(sourceTag)) {
          tags.push(sourceTag);
          input.value = tags.join(',');
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyEditionSourceTag, { once: true });
    } else {
      applyEditionSourceTag();
    }
    document.addEventListener('shopify:section:load', applyEditionSourceTag);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omra-process-detail"] && !Shopify.designMode) return;
  try {
    
(() => {
  const stories = document.querySelectorAll('[data-process-story]');
  if (!stories.length) return;

  const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isMobile = window.matchMedia('(max-width: 749px)').matches;

  stories.forEach((story) => {
    const steps = Array.from(story.querySelectorAll('[data-process-step]'));
    const media = story.querySelector('[data-process-media]');
    const video = story.querySelector('video');
    if (!steps.length || !media) return;

    if (isReducedMotion && video) {
      video.pause();
      video.removeAttribute('autoplay');
    }

    if (!('IntersectionObserver' in window) || isMobile || isReducedMotion) return;

    story.classList.add('is-enhanced');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        steps.forEach((step) => step.classList.toggle('is-active', step === entry.target));
        if (entry.target === steps[steps.length - 1]) media.classList.add('is-revealed');
      });
    }, { rootMargin: '-38% 0px -38% 0px', threshold: 0 });

    steps.forEach((step) => observer.observe(step));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omra-subscription-builder"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>{if(root.dataset.ready)return;root.dataset.ready="true";const products=JSON.parse(root.querySelector("[data-products]").textContent),intro=root.querySelector("[data-intro]"),quiz=root.querySelector("[data-quiz]"),summary=root.querySelector("[data-summary]"),wrap=root.querySelector("[data-step-wrap]"),progress=root.querySelector("[data-progress]"),error=root.querySelector(".osb-quiz [data-error]"),steps=[
{label:"01 / Subscription",question:"Which subscription feels right?",help:"Choose a familiar espresso or let the roastery choose a rotating coffee for you.",key:"plan",options:[{value:"espresso",label:"Espresso Subscription",detail:"A dependable espresso coffee selected by Ómra."},{value:"choice",label:"Roaster’s Choice",detail:"A rotating coffee chosen from the current range."}]},
{label:"02 / Brew",question:"How do you brew?",help:"Choose your grind, or receive whole bean coffee.",key:"grind",options:["Whole Bean","Espresso","French Press","Aeropress","Moka Pot","Filter"].map(value=>({value,label:value}))},
{label:"03 / Size",question:"Choose your bag size.",help:"Pick the amount you’d like in each bag.",key:"size",options:[{value:"250g Bag",label:"250g",detail:"A smaller bag for a few weeks of coffee."},{value:"1Kg Bag",label:"1kg",detail:"A larger bag to keep you stocked between deliveries."}]},
{label:"04 / Quantity",question:"How many bags per delivery?",help:"Choose how many bags you’d like in each delivery.",key:"quantity",options:[]},
{label:"05 / Delivery",question:"How often should it arrive?",help:"Choose a delivery rhythm that suits how quickly you get through coffee.",key:"frequency",options:[2,4,6].map(value=>({value,label:"Every "+value+" weeks"}))}
],state={plan:"",grind:"",size:"",quantity:1,frequency:"",index:0},currency=new Intl.NumberFormat(document.documentElement.lang||"en-GB",{style:"currency",currency:root.dataset.currency||"GBP"});
const variant=()=>{const p=products[state.plan];return p&&p.variants?p.variants.find(v=>v.size===state.size&&v.grind===state.grind):null};
const planFor=v=>v&&v.plans?v.plans.find(p=>p.name.toLowerCase().includes("every "+state.frequency+" week")):null;
const drawProgress=()=>{progress.innerHTML=steps.map((s,i)=>'<button type="button" aria-label="Step '+(i+1)+': '+s.label.substring(5)+'" '+(i===state.index?'aria-current="step"':'')+' '+(i>state.index?'disabled':'')+'></button>').join("");Array.from(progress.children).forEach((b,i)=>b.addEventListener("click",()=>{state.index=i;drawStep()}))};
const drawStep=()=>{const s=steps[state.index],current=state[s.key];drawProgress();wrap.innerHTML='<p class="osb-step-label">'+s.label+'</p><h2 class="osb-question">'+s.question+'</h2><p class="osb-help">'+s.help+'</p>'+(s.key==="quantity"?'<div class="osb-quantity" role="group" aria-label="Bags per delivery"><button type="button" data-qty-minus aria-label="Remove one bag">−</button><output aria-live="polite">'+state.quantity+'</output><button type="button" data-qty-plus aria-label="Add one bag">+</button></div>':'<div class="osb-answers" role="group" aria-label="'+s.question+'">'+s.options.map(o=>'<button type="button" class="osb-answer" aria-pressed="'+(String(current)===String(o.value))+'" data-value="'+o.value+'"><span>'+o.label+'</span>'+(o.detail?'<small>'+o.detail+'</small>':'')+'</button>').join("")+'</div>');if(s.key==="quantity"){wrap.querySelector("[data-qty-minus]").addEventListener("click",()=>{state.quantity=Math.max(1,Number(state.quantity)-1);drawStep()});wrap.querySelector("[data-qty-plus]").addEventListener("click",()=>{state.quantity=Math.min(99,Number(state.quantity)+1);drawStep()})}wrap.querySelectorAll(".osb-answer").forEach(b=>b.addEventListener("click",()=>{state[s.key]=s.key==="quantity"||s.key==="frequency"?Number(b.dataset.value):b.dataset.value;if(s.key==="plan"){state.grind="";state.size="";state.frequency=""}error.hidden=true;drawStep()}));root.querySelector("[data-back]").disabled=state.index===0;root.querySelector("[data-next]").innerHTML=state.index===steps.length-1?'Review subscription <span aria-hidden="true">→</span>':'Continue <span aria-hidden="true">→</span>'};
const valid=()=>{const s=steps[state.index];if(!state[s.key]){error.textContent="Choose an option to continue.";error.hidden=false;return false}if(s.key==="frequency"&&state.plan==="espresso"){const v=variant(),p=planFor(v);if(!v||!v.available||!p){error.textContent="This combination is not currently available. Please choose another option.";error.hidden=false;return false}}return true};
const showSummary=()=>{const p=products[state.plan],v=variant(),plan=planFor(v),draftChoice=state.plan==="choice"&&(!p||!p.id||!v||!plan);if((!p||!v||!plan)&&!draftChoice)return;const productForm=root.querySelector("[data-product-form]");productForm.dataset.productId=String(p.id||"");const total=draftChoice?null:(plan.price/100)*state.quantity,rows=[["Subscription",state.plan==="espresso"?"Espresso Subscription":"Roaster’s Choice"],["Grind",state.grind],["Bag size",state.size.replace(" Bag","")],["Quantity",state.quantity+" bag"+(state.quantity>1?"s":"")],["Delivery","Every "+state.frequency+" weeks"]];root.querySelector("[data-summary-lines]").innerHTML=rows.map(r=>'<div class="osb-summary-line"><span>'+r[0]+'</span><strong>'+r[1]+'</strong></div>').join("");root.querySelector("[data-total]").textContent=draftChoice?"Price shown when product is active":currency.format(total)+" per delivery";root.querySelector("[data-variant]").value=v?v.id:"";root.querySelector("[data-quantity]").value=state.quantity;root.querySelector("[data-selling-plan]").value=plan?plan.id:"";const add=root.querySelector("[data-add]");add.disabled=draftChoice;add.innerHTML=draftChoice?'ROASTER’S CHOICE — DRAFT <span aria-hidden="true">→</span>':add.dataset.liveLabel;root.querySelector("[data-draft-note]").hidden=!draftChoice;quiz.hidden=true;summary.hidden=false};
root.querySelector("[data-start]").addEventListener("click",()=>{intro.hidden=true;quiz.hidden=false;state.index=0;drawStep();wrap.focus()});
root.querySelector("[data-next]").addEventListener("click",()=>{if(!valid())return;if(state.index<steps.length-1){state.index++;drawStep()}else showSummary()});
root.querySelector("[data-back]").addEventListener("click",()=>{if(state.index>0){state.index--;drawStep()}else{quiz.hidden=true;intro.hidden=false}});
root.querySelector("[data-edit]").addEventListener("click",()=>{summary.hidden=true;quiz.hidden=false;state.index=steps.length-1;drawStep()});
const productForm=root.querySelector("[data-product-form]"),addError=summary.querySelector("[data-add-error]"),showAddError=message=>{addError.textContent=message;addError.hidden=false};const describeCartError=event=>{const detail=event?.detail||{},errors=detail.errors;let errorText="";if(typeof errors==="string")errorText=errors;else if(Array.isArray(errors))errorText=errors.map(error=>typeof error==="string"?error:error?.message||error?.description||"").filter(Boolean).join(", ");else if(errors&&typeof errors==="object")errorText=Object.values(errors).flat().map(error=>typeof error==="string"?error:error?.message||error?.description||"").filter(Boolean).join(", ");return detail.description||errorText||detail.error?.message||(typeof detail.error==="string"&&detail.error!=="Cart Error"?detail.error:"")||(event?.error?.message&&event.error.message!=="Cart Error"?event.error.message:"")||"We couldn’t add this subscription. Please check your choices and try again."};productForm.addEventListener("shopify:cart:error",event=>showAddError(describeCartError(event)));productForm.addEventListener("shopify:cart:lines-update",event=>{if(event.action!=="add"||!event.promise)return;event.promise.then(result=>{if(result?.detail?.didError||result?.userErrors?.length){if(addError.hidden)showAddError(result.userErrors?.[0]?.message||"We couldn’t add this subscription. Please check your choices and try again.");return}customElements.whenDefined("theme-drawer").then(()=>{const drawer=document.querySelector("#cart-drawer");if(drawer&&typeof drawer.open==="function")drawer.open()})}).catch(()=>showAddError("We couldn’t update your cart. Please try again."))});
root.querySelector("[data-cart-form]").addEventListener("submit",e=>{const v=variant(),plan=planFor(v),sellingPlan=root.querySelector("[data-selling-plan]"),message=!v||!v.available?"This subscription is not available yet. Please choose another option.":!plan||!sellingPlan?.value?"Please choose a delivery frequency before adding your subscription.":"";if(message){e.preventDefault();showAddError(message);return}addError.hidden=true;addError.textContent=""});
if(window.matchMedia("(min-width: 900px)").matches){intro.hidden=true;quiz.hidden=false;drawStep()}let startX=0;wrap.addEventListener("touchstart",e=>{startX=e.changedTouches[0].screenX},{passive:true});wrap.addEventListener("touchend",e=>{const delta=e.changedTouches[0].screenX-startX;if(Math.abs(delta)<70)return;if(delta<0&&valid()&&state.index<steps.length-1){state.index++;drawStep()}if(delta>0&&state.index>0){state.index--;drawStep()}},{passive:true})};
const all=()=>document.querySelectorAll(".omra-subscription-builder").forEach(init);all();document.addEventListener("shopify:section:load",all)})();

  } catch(e) { console.error(e); }
})();
})();
